import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  LinearProgress,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import { useAppDispatch, useAppSelector } from 'store/store';

import { Loader } from 'components';
import { useInitialLoaderCondition } from 'hooks/useInitialLoaderCondition';
import { useModals } from 'hooks/useModals';
import { MODALS } from 'store/contexts/ModalContext/modals';
import { TLocalizationTable } from './LocalizationTable.types';
import { TLocalizationItem } from 'store/localization/localization.types';

export const LocalizationTable: TLocalizationTable = () => {
  const modals = useModals();
  const dispatch = useAppDispatch();
  // const {
  //   LocalizationList: {
  //     data: LocalizationList,
  //     isLoading: isLocalizationLoading,
  //   },
  //   createLocalization: { isLoading: isCreateLocalizationLoading },
  //   deleteLocalization: { isLoading: isDeleteLocalizationLoading },
  //   updateLocalization: { isLoading: isUpdateLocalizationLoading },
  //   toggleLocalizationActive: {
  //     isLoading: isToggleLocalizationActiveLoading,
  //   },
  // } = useAppSelector((store) => store.Localization);

  const [anchorEl, setAnchorEl] = React.useState<{
    [key: string]: HTMLElement | null;
  }>({});

  // const loadTableItems = React.useCallback(() => {
  //   dispatch(getLocalizationListAsyncThunk());
  // }, [dispatch]);

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    itemId: string
  ) => {
    setAnchorEl({ [itemId]: event.currentTarget });
  };

  const handleMenuClose = (itemId: string) => {
    setAnchorEl((prev) => ({ ...prev, [itemId]: null }));
  };

  const handleEdit = (item: TLocalizationItem) => {
    // handleMenuClose(item.id);
    // modals.openModal(MODALS.ADMIN_Localization_EDIT, { item });
  };

  const handleDelete = (item: TLocalizationItem) => {
    // handleMenuClose(item.id);
    // dispatch(
    //   deleteLocalizationAsyncThunk({
    //     id: item.id,
    //     onSuccess: loadTableItems,
    //   })
    // );
  };

  const handleToggleActive = (item: TLocalizationItem) => {
    // dispatch(
    //   toggleLocalizationActiveAsyncThunk({
    //     id: item.id,
    //     onSuccess: loadTableItems,
    //   })
    // );
  };

  // React.useEffect(() => {
  //   loadTableItems();
  //   return () => {
  //     dispatch(resetLocalizationList());
  //   };
  // }, []);

  // if (!isInitialLoadingFinished) return <Loader />;

  return (
    <div className="entity-table">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ position: 'relative' }}>
              <TableCell className="entity-table__cell">Key</TableCell>
              <TableCell className="entity-table__cell">Value</TableCell>
              <TableCell className="entity-table__cell entity-table__cell--actions">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {LocalizationList?.items?.map((item) => (
              <TableRow key={item.id} className="entity-table__row">
                <TableCell className="entity-table__cell entity-table__cell--switch">
                  <Switch
                    checked={item.isActive}
                    onChange={() => handleToggleActive(item)}
                    size="small"
                  />
                </TableCell>
                <TableCell className="entity-table__cell">
                  {item.name}
                </TableCell>
                <TableCell className="entity-table__cell">
                  <div className="entity-table__color-preview">
                    <div
                      className="entity-table__color-preview-box"
                      style={{ backgroundColor: item.color || '#000000' }}
                    />
                    <span>{item.color || 'No color'}</span>
                  </div>
                </TableCell>
                <TableCell className="entity-table__cell entity-table__cell--actions">
                  <IconButton
                    size="small"
                    onClick={(e) => handleMenuOpen(e, item.id)}
                    className="entity-table__menu-button"
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl[item.id]}
                    open={Boolean(anchorEl[item.id])}
                    onClose={() => handleMenuClose(item.id)}
                  >
                    <MenuItem
                      onClick={() => handleEdit(item)}
                      className="entity-table__menu-item"
                    >
                      <EditIcon fontSize="small" sx={{ mr: 1 }} />
                      Edit
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleDelete(item)}
                      className="entity-table__menu-item entity-table__menu-item--delete"
                    >
                      <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
                      Delete
                    </MenuItem>
                  </Menu>
                </TableCell>
              </TableRow>
            ))} */}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
